import { Controller } from "@hotwired/stimulus"
// import throttle from 'lodash.throttle'

export default class extends Controller {
  static targets = ["submitButton"]

  connect() {} 

  submit () {
    this.element.requestSubmit(this.submitButtonTarget) // Programatically submit the form.
  }

}